import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
} from "@material-ui/core/";
import moment from "moment";

import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import { useSelector, useDispatch } from "react-redux";
import {
  removeParticularModalData,
  updatePrice,
} from "../../../../reduxSlices/selectClassSlice";
import {
  isObjectEmpty,
  classStatusOptionList,
} from "../../../../utils/general";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../../reduxSlices/loginSlice";
import Backdrop from "../../../Backdrop";
import Aux from "../../../../hoc/Auxilliary";
import MessageIndicator from "../../../SnackBar";
import localizedStrings from "../../../../utils/localize";
import { clearDuplicateSelectClassMessage } from "../../../../reduxSlices/selectClassSlice";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },

  formControl: {
    color: "white",
  },
  classFont: {
    fontSize: "1.8rem",
    fontWeight: 500,
    flex: 1,
  },
});
const styles = {
  fontSize: "1.2rem",
  background: "#efd6e1",
  padding: "6px 13px",
};
function PageConatiner(props) {
  const dispatch = useDispatch();

  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });

  const [tableMapData, setTableMapData] = useState([]);

  const selectClassData = useSelector(
    (state) => state.selectClassData.selectClassData,
  );

  const price = useSelector((state) => state.selectClassData.price);
  const dataFetchingStatus = useSelector(
    (state) => state.selectClassData.dataFetchingStatus,
  );
  const optionList = useSelector((state) => state.applicationData.optionList);
  const errorMessage = useSelector(
    (state) => state.selectClassData.errorMessage,
  );

  const errorStatusCode = useSelector(
    (state) => state.selectClassData.errorStatusCode,
  );

   const dscErrorMessage = useSelector(
    (state) => state.selectClassData.dscErrorMessage,
  );

  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
  };

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    props.history.push("/login");
  };

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: `${localizedStrings.general.sessionexpired}`,
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);

  const handleDelete = (ses_classid) => {
    const copyTableMapData = [...tableMapData];

    dispatch(
      removeParticularModalData(
        copyTableMapData.filter((data) => data.ses_classid !== ses_classid),
      ),
    );
  };

  const handleClick = (e) => {
    dispatch(clearDuplicateSelectClassMessage(false));
    e.preventDefault();
    props.history.push({
      pathname: "/students/select-class/checkout",
    });
  };

  const calcuatePrice = (selectClassData) => {
    let intialPrice = 0;
    selectClassData.forEach((element) => {
      intialPrice += parseInt(element.price);
    });
    dispatch(updatePrice(intialPrice));
  };
  useEffect(() => {
    if (selectClassData.length > 0) {
      calcuatePrice(selectClassData);
      setTableMapData(selectClassData);
    }
  }, [selectClassData]);

  function formatCredits(credits) {
    if (credits === 0) {
      return "0,00";
    } else {
      return credits
        ?.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
        .replace(".", ",");
    }
  }

  let tableData = "";
  if (selectClassData.length > 0) {
    if (selectClassData) {
      if (Array.isArray(selectClassData)) {
        tableData =
          tableMapData.length > 0
            ? tableMapData.map((element, index) => {
                return (
                  <StyledTableRow key={index}>
                     <StyledTableCell>
                      <IconButton
                        onClick={() => handleDelete(element.ses_classid)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {element.ses_termname}
                    </StyledTableCell>
                    <StyledTableCell>
                      {element.ses_institutionclassid === (undefined || null)
                        ? ""
                        : ` ${element?.ses_institutionclassid}- ${element?.ses_classname}`}
                      <br />
                      {element?.ses_roomname === (undefined || null)
                        ? ""
                        : `${element?.ses_roomname}`}
                    </StyledTableCell>
                    <StyledTableCell>
                      {element.ses_departmentname} <br />
                      {
                        localizedStrings.students.selectClasses.modalTable
                          .startDate
                      }{" "}
                      -{" "}
                      {`${
                        element.ses_startdate != null
                          ? moment(element.ses_startdate).format("YYYY-MM-DD")
                          : ""
                      }`}
                      <br />
                      {
                        localizedStrings.students.selectClasses.modalTable
                          .endDate
                      }
                      -{" "}
                      {` ${
                        element.ses_enddate != null
                          ? moment(element.ses_enddate).format("YYYY-MM-DD")
                          : ""
                      }`}
                    </StyledTableCell>
                    <StyledTableCell>
                      {classStatusOptionList(element.ses_classstatus)}
                    </StyledTableCell>
                    <StyledTableCell>
                      {formatCredits(element.ses_creditsavailable)}
                    </StyledTableCell>
                    <StyledTableCell>
                      {element.usb_classnote ? element.usb_classnote : ""}
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })
            : null;
      }
    }
  }
  useEffect(() => {
    if (
      error.message ===
      "The student cannot be enrolled because all of the prerequisites for the course have not been met."
    ) {
      let error = {
        isError: false,
        message: "",
        showSnackbar: false,
      };
      setError(error);
    }
  }, [error]);
  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={error.message}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      {dscErrorMessage && (
        <>
          <Typography
            component="div"
            style={styles}
          >
            {localizedStrings.students.selectClasses.table.message}
          </Typography>
          <br />
        </>
      )}
      <TableContainer
        component={Paper}
        style={{ minHeight: "40vh", marginBottom: "10px" }}
      >
        <Table aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.table.action}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.table.term}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.table.course}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.table.description}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.table.classStatus}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.table.credits}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.table.classNotes}
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>{tableData}</TableBody>
        </Table>
      </TableContainer>
      {selectClassData.length > 0 && (
        <Typography
          component="div"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1rem",
            width: "100%",
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            style={{ textTransform: "capitalize", marginLeft: "0.5rem" }}
            endIcon={<NavigateNextIcon />}
            onClick={handleClick}
          >
            {localizedStrings.students.selectClasses.next}
          </Button>
        </Typography>
      )}
    </Aux>
  );
}

export default withRouter(PageConatiner);
